// SAFed visit photographs on the phone (Session BDB, Part 3). They use the platform's existing job photo path and offline outbox
// (queuePhoto, POST /api/jobs/:id/photos), not a store of their own. A visit holds six. A photograph carries no time or place that
// we were told, so nothing here labels one as taken at a time or place, and no location is ever requested.
export const SAFED_PHOTO_CAP = 6;
export const SAFED_PHOTO_CAP_MESSAGE = "A visit holds up to 6 photos. Remove one in the office before adding another.";
